(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["isikli-iletisim"] && !Shopify.designMode) return;
  try {
    class IsikliIletisim extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section, dialog');
      this.onUpdate = this.onUpdate.bind(this);
      this.root && this.root.addEventListener('variant:update', this.onUpdate);
      this.apply();
    }

    disconnectedCallback() {
      this.root && this.root.removeEventListener('variant:update', this.onUpdate);
    }

    onUpdate(event) {
      const data = event.detail && event.detail.data;
      if (!data || !data.html) return;
      if (data.newProduct) {
        this.dataset.productId = String(data.newProduct.id);
      } else if (data.productId && String(data.productId) !== this.dataset.productId) {
        return;
      }
      const fresh = data.html.querySelector('isikli-iletisim[data-block-id="' + this.dataset.blockId + '"]');
      if (!fresh) return;
      this.dataset.isikli = fresh.dataset.isikli;
      this.innerHTML = fresh.innerHTML;
      this.apply();
    }

    apply() {
      const on = this.dataset.isikli === 'true';
      if (this.root) this.root.classList.toggle('isikli-secili', on);
      const init = this.root && this.root.querySelector('style[id^="isikli-init-"]');
      if (init && this.root.classList.contains('isikli-secili')) init.remove();
    }
  }
  if (!customElements.get('isikli-iletisim')) customElements.define('isikli-iletisim', IsikliIletisim);
  } catch(e) { console.error(e); }
})();

})();
